import React, { useEffect } from "react";

const SEO = ({ title, description, keywords, url, organization }) => {
  useEffect(() => {
    if (title) document.title = title;

    // Helper to set or update meta tag
    const setMeta = (name, content, property = false) => {
      if (!content) return;
      let selector = property
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
      let element = document.head.querySelector(selector);
      if (!element) {
        element = document.createElement("meta");
        if (property) element.setAttribute("property", name);
        else element.setAttribute("name", name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:url", url, true);
    setMeta("og:type", "website", true);
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:card", "summary_large_image");

    // Canonical link
    if (url) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    }

    // Structured data (organization)
    if (organization) {
      let script = document.head.querySelector('script[data-seo-org="true"]');
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-seo-org", "true");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(organization);
    }

    // Cleanup function (optional: remove tags if component unmounts)
    return () => {
      // ...existing code...
    };
  }, [title, description, keywords, url, organization]);

  return null;
};

export default SEO;
